export default "__VITE_ASSET__C8NVYt07__"